<template>
    <Navbar @cor="tema($event)" @traduzir="traduz($event)" />

    <div :class="{'politica': cor == false, 'politicadark': cor == true}">
        <div v-if="traduzir == true">
            <h1>Política de Privacidade</h1>

            <p>Esta Política de Privacidade descreve como coletamos, usamos e protegemos as informações pessoais dos usuários do nosso site. Ao utilizar nosso site, você concorda com os termos desta política.</p>

            <h2>Coleta de Informações</h2>
            <p>Coletamos informações pessoais, como nome, endereço de e-mail e número de telefone, quando você preenche formulários em nosso site ou entra em contato conosco.</p>

            <h2>Uso das Informações</h2>
            <p>As informações coletadas são usadas para responder às suas solicitações, fornecer suporte ao cliente e enviar atualizações sobre nossos produtos e serviços.</p>

            <h2>Uso de Cookies</h2>
            <p>Utilizamos cookies para armazenar temporariamente informações necessárias para melhorar a navegação e a experiência do usuário no site. Os cookies essenciais são carregados automaticamente, enquanto outros só são ativados com seu consentimento. Você pode alterar suas permissões a qualquer momento através do nosso banner ou das configurações do seu navegador.</p>

            <h2>Proteção das Informações</h2>
            <p>Implementamos medidas de segurança para proteger suas informações pessoais contra acesso não autorizado, alteração, divulgação ou destruição.</p>

            <h2>Compartilhamento de Informações</h2>
            <p>Não compartilhamos suas informações pessoais com terceiros, exceto quando necessário para cumprir a lei ou proteger nossos direitos.</p>

            <h2>Alterações na Política de Privacidade</h2>
            <p>Podemos atualizar esta Política de Privacidade periodicamente. Recomendamos que você revise esta página regularmente para se manter informado sobre quaisquer alterações.</p>

            <h2>Contato</h2>
            <p>Se você tiver alguma dúvida sobre nossa Política de Privacidade, entre em contato conosco através do e-mail: <a href="mailto:souzosolucoesdigitais@gmail.com?subject=Orçamento&body=Escreva sua mensagem aqui." target="_blank">souzosolucoesdigitais@gmail.com</a></p>
        </div>

        <div v-else>
            <h1>Privacy Policy</h1>

            <p>This Privacy Policy describes how we collect, use, and protect the personal information of users of our website. By using our website, you agree to the terms of this policy.</p>

            <h2>Information Collection</h2>
            <p>We collect personal information such as name, email address, and phone number when you fill out forms on our website or contact us.</p>

            <h2>Use of Information</h2>
            <p>The information collected is used to respond to your inquiries, provide customer support, and send updates about our products and services.</p>

            <h2>Use of Cookies</h2>
            <p>We use cookies to temporarily store information necessary to improve navigation and the user experience on the website. Essential cookies are loaded automatically, while others are only activated with your consent. You can change your permissions at any time through our banner or your browser settings.</p>
            
            <h2>Information Protection</h2>
            <p>We implement security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction.</p>

            <h2>Information Sharing</h2>
            <p>We do not share your personal information with third parties except when necessary to comply with the law or protect our rights.</p>

            <h2>Changes to the Privacy Policy</h2>
            <p>We may update this Privacy Policy periodically. We recommend that you review this page regularly to stay informed about any changes.</p>

            <h2>Contact</h2>
            <p>If you have any questions about our Privacy Policy, please contact us via email: <a href="mailto:souzosolucoesdigitais@gmail.com?subject=Orçamento&body=Escreva sua mensagem aqui." target="_blank">souzosolucoesdigitais@gmail.com</a></p>
        </div>
    
    </div>

    <Direitos :cor="cor" :traduzir="traduzir" />
</template>

<script>
import { useUsuarioStore } from '../stores/autenticacao'; //pinia cookie do navegador

import Navbar from '@/components/Navbar.vue';
import Direitos from '@/components/Direitos.vue';

export default {
    name: 'PoliticaDePrivacidade',

    data(){
        return{
        cor: false,
        traduzir: false,
        }
    },

    created(){
        this.atualiza()
    },

    components: {
        Navbar,
        Direitos
    },

     methods: {
        atualiza(){
            const store = useUsuarioStore();

            this.traduzir = store.portugues;
            this.cor = store.diurno;
        },

        traduz(dado){
            //console.log(dado);
            this.traduzir = dado.traduzir;
            //console.log(this.traduzir);
        },

        tema(dado){
            this.cor = dado.cor;
        }
    }
}

</script>

<style src="./politica.scss" lang="scss" scoped></style>